class GenderButtons extends HTMLElement {
  connectedCallback() {
    this.filterIdAll = 'all';
    this.filterIdMens = this.dataset.mensFilter;
    this.filterIdWomens = this.dataset.womensFilter;

    this.allButton = this.querySelector(`[data-filter="${this.filterIdAll}"]`);
    this.womensButton = this.querySelector(`[data-filter="${this.filterIdWomens}"]`);
    this.mensButton = this.querySelector(`[data-filter="${this.filterIdMens}"]`);

    this.womensTarget = `#collection-filter-drawer label[for="${this.filterIdWomens}"]`;
    this.mensTarget = `#collection-filter-drawer label[for="${this.filterIdMens}"]`;

    this.bindEvents();

    this.detectBasedOnQueryString();
  }

  /**
   * Check the URL parameters to see if womens or mens filters are active
   * @returns { womenIsFiltered: boolean, menIsFiltered: boolean, allActive: boolean }
   */
  checkUrlParameters() {
    const womenIsFiltered = window.location.search.match(`gender-${this.filterIdWomens}|,${this.filterIdWomens}`);
    const menIsFiltered = window.location.search.match(`gender-${this.filterIdMens}|,${this.filterIdMens}`);

    return {
      womenIsFiltered,
      menIsFiltered,
      allActive: (!womenIsFiltered && !menIsFiltered) || (womenIsFiltered && menIsFiltered),
    };
  }

  /**
   * Update button states based on URL parameters
   */
  detectBasedOnQueryString() {
    setTimeout(() => {
      const { womenIsFiltered, menIsFiltered } = this.checkUrlParameters();

      if (womenIsFiltered && !menIsFiltered) {
        this.allButton.removeAttribute('active');
        this.mensButton.removeAttribute('active');
        this.womensButton.setAttribute('active', true);
      } else if (menIsFiltered && !womenIsFiltered) {
        this.allButton.removeAttribute('active');
        this.womensButton.removeAttribute('active');
        this.mensButton.setAttribute('active', true);
      } else {
        this.womensButton.removeAttribute('active');
        this.mensButton.removeAttribute('active');
        this.allButton.setAttribute('active', true);
      }
    }, 64);
  }

  bindEvents() {
    /**
     * Handle the click on the filter checkboxes in the filter drawer.
     * - Uses event delegation to track clicks on Tagalys filter drawer
     * - Uses `nextElementSibling` to find the label for the checkbox that was clicked,
     *   as the `event.target` is the checkbox input itself.
     */
    document.querySelector('[data-search-results]').addEventListener('click', (ev) => {
      if (
        ev.target?.nextElementSibling?.matches(this.mensTarget) ||
        ev.target?.nextElementSibling?.matches(this.womensTarget)
      ) {
        this.detectBasedOnQueryString();
      }
    });

    this.allButton.addEventListener('click', (ev) => {
      const { womenIsFiltered, menIsFiltered, allActive } = this.checkUrlParameters();
      // If all is active, do nothing
      if (allActive) return;

      // If womens is active, deactivate womens
      if (womenIsFiltered) {
        document.querySelector(this.womensTarget)?.click();
      }
      // If mens is active, deactivate mens
      if (menIsFiltered) {
        document.querySelector(this.mensTarget)?.click();
      }
      this.detectBasedOnQueryString();
    });

    this.womensButton.addEventListener('click', (ev) => {
      const { womenIsFiltered, menIsFiltered, allActive } = this.checkUrlParameters();
      // if womens is active, do nothing
      if (womenIsFiltered) return;
      // if mens is active, deactivate mens and activate womens
      if (menIsFiltered) {
        document.querySelector(this.mensTarget)?.click();
        setTimeout(() => document.querySelector(this.womensTarget)?.click(), 64);
      }
      // if all is active, activate womens
      if (allActive) {
        document.querySelector(this.womensTarget)?.click();
      }
      this.detectBasedOnQueryString();
    });

    this.mensButton.addEventListener('click', (ev) => {
      const { womenIsFiltered, menIsFiltered, allActive } = this.checkUrlParameters();
      // if mens is active, do nothing
      if (menIsFiltered) return;
      // if womens is active, deactivate womens and activate mens
      if (womenIsFiltered) {
        document.querySelector(this.womensTarget)?.click();
        setTimeout(() => document.querySelector(this.mensTarget)?.click(), 64);
      }
      // if all is active, activate mens
      if (allActive) {
        document.querySelector(this.mensTarget)?.click();
      }

      this.detectBasedOnQueryString();
    });
  }

  resetAllButton() {
    if (!this.mensButton.hasAttribute('active') && !this.womensButton.hasAttribute('active')) {
      this.allButton.toggleAttribute('active', true);
    }
  }
}

customElements.define('gender-buttons', GenderButtons);
